<template>
  <div class="content">
    <header>
      <div class="header-view">
        <logo></logo>
        <router-link to="/login" class="login">登录</router-link>
      </div>
    </header>
    <section>
      <div class="main">
        <div class="regist-top">
          <p>完善资料</p>
          <p>完善画像，享受更精准的企业服务</p>
        </div>
        <div class="step-view">
          <el-steps :active="active" align-center>
            <el-step title="基本信息"></el-step>
            <el-step title="研发创新"></el-step>
            <el-step title="厂房场地"></el-step>
            <el-step title="人力资源"></el-step>
            <el-step title="融资上市"></el-step>
            <el-step title="生产经营"></el-step>
          </el-steps>
        </div>
        <div class="register-content">
          <div class="step-item step-1">
            <h3 class="register_title">
              {{ this.submitKey[this.active].name }}：
            </h3>
            <el-form
              :model="ruleForm"
              :rules="rules"
              class="login-form"
              ref="registerForm"
              label-width="154px"
              v-show="active == 0"
              style="width: 50%"
            >
              <el-form-item label="企业名称:" prop="entName">
                <el-select
                  style="width: 100%"
                  v-model="ruleForm.entName"
                  filterable
                  remote
                  placeholder="请输入企业名称"
                  no-data-text="您输入的企业不存在，请重新输入"
                  :remote-method="remoteMethod"
                  @change="entNameChange"
                  :loading="entNameLoading"
                >
                  <el-option
                    v-for="item in entNameList"
                    :key="item.SHXYDM"
                    :label="item.ENTNAME"
                    :value="item.SHXYDM"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="统一社会信用代码:" prop="socialCreditCode">
                <el-input
                  v-model="ruleForm.socialCreditCode"
                  placeholder="统一社会信用代码"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="企业属地:" prop="territory">
                <el-select
                  style="width: 100%"
                  v-model="ruleForm.territory"
                  placeholder="请选择企业属地"
                  collapse-tags
                >
                  <el-option
                    v-for="item in territoryOption"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系人:" prop="cnname">
                <el-input
                  v-model="ruleForm.cnname"
                  maxlength="20"
                  placeholder="请输入联系人"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人电话:" prop="mobile">
                <el-input
                  v-model="ruleForm.mobile"
                  placeholder="请输入联系人电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="密码:" prop="password">
                <el-input
                  v-model="ruleForm.password"
                  show-password
                  auto-complete="new-password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
              <el-form-item label="企业类型:" prop="entType">
                <el-select
                  style="width: 100%"
                  v-model="ruleForm.entType"
                  placeholder="企业类型"
                  collapse-tags
                >
                  <el-option
                    v-for="item in entTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="产业:" prop="industry">
                <el-select
                  style="width: 100%"
                  v-model="ruleForm.industry"
                  placeholder="请选择产业"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in industryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="成长阶段:" prop="growthStage">
                <el-select
                  style="width: 100%"
                  v-model="ruleForm.growthStage"
                  placeholder="请选择成长阶段"
                  collapse-tags
                >
                  <el-option
                    v-for="item in growthStageList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="行业：" prop="business">
                <el-cascader
                  style="width: 100%"
                  v-model="ruleForm.business"
                  :options="businessList"
                  ref="industryCascader"
                  :props="{
                    expandTrigger: 'hover',
                    label: 'name',
                    value: 'id'
                  }"
                  @change="industryChange"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="营业收入:" prop="taking">
                <el-select
                  style="width: 100%"
                  v-model="ruleForm.taking"
                  placeholder="请选择营业收入"
                  :disabled="editState"
                >
                  <el-option
                    v-for="item in takingList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="`${industryKey[name].name}：`"
                v-for="(value, name) in optionList"
                :key="industryKey[name].value"
                :prop="industryKey[name].value"
              >
                <el-select
                  v-model="ruleForm[industryKey[name].value]"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in value"
                    :key="index"
                    :label="item.optionValue"
                    :value="item.optionCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="企业简介:">
                <el-input
                  type="textarea"
                  placeholder="请选择企业简介"
                  v-model="ruleForm.enterpriseProfile"
                  maxlength="300"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-form>
            <!-- 研发创新 -->
            <el-form
              :model="YFCXForm"
              :rules="YFCXRules"
              class="login-form"
              ref="YFCXForm"
              label-width="184px"
              v-show="active == 1"
            >
              <el-form-item label="有无技术转移转化:">
                <el-radio v-model="YFCXForm.ywjszyzh" label="1">是</el-radio>
                <el-radio v-model="YFCXForm.ywjszyzh" label="0">否</el-radio>
              </el-form-item>
              <el-form-item label="有无自主研发的新产品:">
                <el-radio v-model="YFCXForm.ywzzyfdxcp" label="1">是</el-radio>
                <el-radio v-model="YFCXForm.ywzzyfdxcp" label="0">否</el-radio>
              </el-form-item>
              <el-form-item label="有无国际合作和产学研:">
                <el-radio v-model="YFCXForm.ywgjhzhcxy" label="1">是</el-radio>
                <el-radio v-model="YFCXForm.ywgjhzhcxy" label="0">否</el-radio>
              </el-form-item>
              <el-form-item label="是否有研发人员:">
                <el-radio-group
                  v-model="YFCXForm.sfyyfry"
                  @change="sfyyfryChange"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="YFCXForm.sfyyfry == 1"
                label="研发人员:"
                prop="yfry"
              >
                <el-select
                  style="width: 240px"
                  v-model="YFCXForm.yfry"
                  placeholder="请选择研发人员"
                >
                  <el-option
                    v-for="item in yfryList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="YFCXForm.sfyyfry == 1"
                label="研发人员数量变动:"
                prop="yfryslbd"
              >
                <el-select
                  style="width: 240px"
                  v-model="YFCXForm.yfryslbd"
                  placeholder="请选择研发人员数量变动"
                >
                  <el-option
                    v-for="item in yfryslbdList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 厂房场地 -->
            <el-form
              :model="CFCDForm"
              :rules="CFCDRules"
              class="login-form"
              ref="CFCDForm"
              label-width="184px"
              v-show="active == 2"
            >
              <el-form-item label="现有厂房场地情况:">
                <el-radio-group
                  v-model="CFCDForm.xycfcdqk"
                  @change="xycfcdqkChange"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="CFCDForm.xycfcdqk == 1"
                label="现有厂房面积:"
                prop="xycfmj"
              >
                <el-select
                  style="width: 240px"
                  v-model="CFCDForm.xycfmj"
                  placeholder="请选择现有厂房面积"
                >
                  <el-option
                    v-for="item in xycfmjList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="现有办公场地情况:">
                <el-radio-group
                  v-model="CFCDForm.xybgcdqk"
                  @change="xybgcdqkChange"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="CFCDForm.xybgcdqk == 1"
                label="现有办公面积:"
                prop="xybgmj"
              >
                <el-select
                  style="width: 240px"
                  v-model="CFCDForm.xybgmj"
                  placeholder="请选择现有办公面积"
                >
                  <el-option
                    v-for="item in xybgmjList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否有用地需求:">
                <el-radio-group
                  v-model="CFCDForm.sfyydxq"
                  @change="sfyydxqChange"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="CFCDForm.sfyydxq == 1"
                label="用地需求类型:"
                prop="ydxqlx"
              >
                <el-select
                  style="width: 240px"
                  v-model="CFCDForm.ydxqlx"
                  placeholder="请选择用地需求类型"
                >
                  <el-option
                    v-for="item in ydxqlxList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="场地类型:"
                v-if="CFCDForm.sfyydxq == 1"
                prop="cdlx"
              >
                <el-radio-group v-model="CFCDForm.cdlx" @change="cdlxChange">
                  <el-radio label="1">办公室</el-radio>
                  <el-radio label="0">厂房</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="CFCDForm.cdlx == 1"
                label="办公室场地面积:"
                prop="bgscdmj"
              >
                <el-select
                  style="width: 240px"
                  v-model="CFCDForm.bgscdmj"
                  placeholder="请选择办公室场地面积"
                >
                  <el-option
                    v-for="item in bgscdmjList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="CFCDForm.cdlx === '0'"
                label="厂房场地面积:"
                prop="cfcdmj"
              >
                <el-select
                  style="width: 240px"
                  v-model="CFCDForm.cfcdmj"
                  placeholder="请选择厂房场地面积"
                >
                  <el-option
                    v-for="item in cfcdmjList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 人力资源 -->
            <el-form
              :model="RLZYForm"
              :rules="RLZYRules"
              class="login-form"
              ref="RLZYForm"
              label-width="184px"
              v-show="active == 3"
            >
              <el-form-item label="员工人数:">
                <el-select
                  style="width: 240px"
                  v-model="RLZYForm.ygrs"
                  placeholder="请选择员工人数"
                  collapse-tags
                >
                  <el-option
                    v-for="item in selectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否有用工需求:">
                <el-radio-group
                  v-model="RLZYForm.sfyygxq"
                  @change="sfyygxqChange"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="RLZYForm.sfyygxq == 1"
                label="劳动用工需求量:"
                prop="ldygxql"
              >
                <el-select
                  style="width: 240px"
                  v-model="RLZYForm.ldygxql"
                  placeholder="请选择劳动用工需求量"
                >
                  <el-option
                    v-for="item in selectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="留学归国人员数:">
                <el-select
                  style="width: 240px"
                  v-model="RLZYForm.lxggrys"
                  placeholder="请选择留学归国人员数"
                >
                  <el-option
                    v-for="item in selectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="外籍常驻人员数:">
                <el-select
                  style="width: 240px"
                  v-model="RLZYForm.wjczrys"
                  placeholder="请选择外籍常驻人员数"
                >
                  <el-option
                    v-for="item in selectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="博士研究生人数:">
                <el-select
                  style="width: 240px"
                  v-model="RLZYForm.bsyjsrs"
                  placeholder="请选择博士研究生人数"
                >
                  <el-option
                    v-for="item in selectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="硕士研究生人数:">
                <el-select
                  style="width: 240px"
                  v-model="RLZYForm.ssyjsrs"
                  placeholder="请选择硕士研究生人数"
                >
                  <el-option
                    v-for="item in selectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="本科人数:">
                <el-select
                  style="width: 240px"
                  v-model="RLZYForm.bkrs"
                  placeholder="请选择本科人数"
                >
                  <el-option
                    v-for="item in selectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="参保人员:">
                <el-select
                  style="width: 240px"
                  v-model="RLZYForm.cbry"
                  placeholder="请选择参保人员"
                >
                  <el-option
                    v-for="item in selectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 融资上市 -->
            <el-form
              :model="RZSSForm"
              :rules="RZSSRules"
              class="login-form"
              ref="RZSSForm"
              label-width="184px"
              v-show="active == 4"
            >
              <el-form-item label="融资轮数:">
                <el-select
                  style="width: 240px"
                  v-model="RZSSForm.rzls"
                  placeholder="请选择融资轮数"
                >
                  <el-option
                    v-for="item in rzlsList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否有融资需求:">
                <el-radio-group
                  v-model="RZSSForm.sfyrzxq"
                  @change="sfyrzxqChange"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="融资方式:"
                v-if="RZSSForm.sfyrzxq == 1"
                prop="rzfs"
              >
                <el-radio-group v-model="RZSSForm.rzfs" @change="rzfsChange">
                  <el-radio label="1">债权融资</el-radio>
                  <el-radio label="2">股权融资</el-radio>
                  <el-radio label="3">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="RZSSForm.rzfs == 1"
                label="债权融资需求金额:"
                prop="zqrzxqje"
              >
                <el-select
                  style="width: 240px"
                  v-model="RZSSForm.zqrzxqje"
                  placeholder="请选择债权融资需求金额"
                >
                  <el-option
                    v-for="item in zqrzxqjeList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="RZSSForm.rzfs == 2"
                label="股权融资需求金额:"
                prop="gqrzxqje"
              >
                <el-select
                  style="width: 240px"
                  v-model="RZSSForm.gqrzxqje"
                  placeholder="请选择股权融资需求金额"
                >
                  <el-option
                    v-for="item in zqrzxqjeList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否上市:">
                <el-radio-group v-model="RZSSForm.sfss" @change="sfssChange">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="RZSSForm.sfss == '0'"
                label="是否有上市计划:"
                prop="sfyssjh"
              >
                <el-select
                  style="width: 240px"
                  v-model="RZSSForm.sfyssjh"
                  placeholder="请选择股权融资需求金额"
                >
                  <el-option
                    v-for="item in sfyssjhList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="RZSSForm.sfyssjh == '1'"
                label="计划上市模块:"
                prop="jhssmk"
              >
                <el-select
                  style="width: 240px"
                  v-model="RZSSForm.jhssmk"
                  placeholder="请选择计划上市模块"
                >
                  <el-option
                    v-for="item in jhssmkList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="RZSSForm.sfss == '1'"
                label="上市模块:"
                prop="ssmk"
              >
                <el-select
                  style="width: 240px"
                  v-model="RZSSForm.ssmk"
                  placeholder="请选择上市模块"
                >
                  <el-option
                    v-for="item in jhssmkList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 生产经营 -->
            <el-form
              :model="SCJYForm"
              class="login-form"
              ref="SCJYForm"
              label-width="184px"
              v-show="active == 5"
            >
              <el-form-item label="主营业务及产品说明:">
                <el-input
                  type="textarea"
                  placeholder="请输入主营业务及产品说明"
                  v-model="SCJYForm.zyywjcpsm"
                  maxlength="300"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
              <el-form-item label="主营业务规模:">
                <el-select
                  style="width: 240px"
                  v-model="SCJYForm.zyywgm"
                  placeholder="请选择主营业务规模"
                >
                  <el-option
                    v-for="item in zyywgmList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="有无技术改造项目:">
                <el-radio-group v-model="SCJYForm.ywjsgzxm">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="有无境外投资项目:">
                <el-radio-group v-model="SCJYForm.ywjwtzxm">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="纳税规模:">
                <el-select
                  style="width: 240px"
                  v-model="SCJYForm.nsgm"
                  placeholder="请选择纳税规模"
                >
                  <el-option
                    v-for="item in nsgmList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="实缴税金（万元）:">
                <el-input
                  style="width: 240px"
                  v-model="SCJYForm.sjzj"
                  placeholder="请输入实缴税金"
                  maxlength="12"
                  @input="numberTemplate($event, 'sjzj')"
                ></el-input>
              </el-form-item>
              <el-form-item label="净资产（万元）:">
                <el-input
                  style="width: 240px"
                  v-model="SCJYForm.jzc"
                  placeholder="请输入净资产"
                  maxlength="12"
                  @input="numberTemplate($event, 'jzc')"
                ></el-input>
              </el-form-item>
              <el-form-item label="销售收入（万元）:">
                <el-input
                  style="width: 240px"
                  v-model="SCJYForm.xssr"
                  placeholder="请输入销售收入"
                  maxlength="12"
                  @input="numberTemplate($event, 'xssr')"
                ></el-input>
              </el-form-item>
              <el-form-item label="营业收入（万元）:">
                <el-input
                  style="width: 240px"
                  v-model="SCJYForm.yysr"
                  placeholder="请输入营业收入"
                  maxlength="12"
                  @input="numberTemplate($event, 'yysr')"
                ></el-input>
              </el-form-item>
              <el-form-item label="研发经费支出（万元）:">
                <el-input
                  style="width: 240px"
                  v-model="SCJYForm.yfjfzc"
                  placeholder="请输入研发经费支出"
                  maxlength="12"
                  @input="numberTemplate($event, 'yfjfzc')"
                ></el-input>
              </el-form-item>
              <el-form-item label="净利润（万元）:">
                <el-input
                  style="width: 240px"
                  v-model="SCJYForm.jlr"
                  placeholder="请输入净利润"
                  maxlength="12"
                  @input="numberTemplate($event, 'jlr')"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="button-box">
            <el-button
              type="primary"
              style="margin-top: 10px; padding: 10px 27px"
              v-if="active > 0"
              @click="loginPrev"
            >
              上一步
            </el-button>
            <el-button
              type="primary"
              style="margin-top: 10px; padding: 10px 27px"
              v-if="active != 5"
              @click="loginNext"
            >
              下一步
            </el-button>
            <el-button
              :loading="loading"
              type="primary"
              style="margin-top: 10px; padding: 10px 27px"
              @click.native.prevent="handleLogin"
            >
              提交
            </el-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Logo from "@/layout/components/Sidebar/Logo.vue";
import {
  getEntByKeyword,
  isRegister,
  getPhoneCode,
  // eslint-disable-next-line no-unused-vars
  getRegisterUser,
  getIndustry,
  getList,
  getDropDown,
  getComSearch
} from "@/api/app";
import YFCX from "./modules/YFCX";
import CFCD from "./modules/CFCD";
import RLZY from "./modules/RLZY";
import RZSS from "./modules/RZSS";
import SCJY from "./modules/SCJY";
export default {
  mixins: [YFCX, CFCD, RLZY, RZSS, SCJY],
  data() {
    const validatePhone = async (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确手机号"));
      } else {
        let { data } = await isRegister({ number: value });
        if (data) {
          callback(new Error("手机号已注册,请重新输入"));
        } else {
          callback();
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8 || value.length > 15) {
        callback(new Error("密码长度需满足8-15位"));
      } else {
        if (this.ruleForm.confirmPassword !== "") {
          // this.$refs.registerForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    return {
      codeState: false,
      active: 0,
      time_s: 60,
      timeInterval: null,
      obtainCode: "获取验证码",
      entNameList: [],
      entNameLoading: false,
      loading: false,
      territoryOption: [],
      ruleForm: {
        entName: "",
        socialCreditCode: "",
        cnname: "",
        password: "",
        mobile: "",
        entType: "",
        industry: [],
        growthStage: "", //成长阶段
        business: [],
        totalAssets: "",
        practitioner: "",
        taking: "",
        enterpriseProfile: "",
        territory: ""
      },
      entTypeList: [], // 企业类型
      industryList: [], // 产业
      growthStageList: [], //成长阶段
      businessList: [], //行业
      rules: {
        entName: [
          { required: true, message: "请输入企业名称", trigger: "change" }
        ],
        socialCreditCode: [
          {
            required: true,
            message: "请输入社会统一信用代码",
            trigger: "change"
          }
        ],
        cnname: [
          {
            required: true,
            message: "为了方便与您联系，请输入联系人姓名",
            trigger: "blur"
          }
        ],
        mobile: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        territory: [
          {
            required: true,
            message: "请选择企业属地",
            trigger: "change"
          }
        ],
        entType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: "change"
          }
        ],
        industry: [
          {
            required: true,
            message: "请选择产业",
            trigger: "change"
          }
        ],
        growthStage: [
          {
            required: true,
            message: "请选择成长阶段",
            trigger: "change"
          }
        ],
        business: [
          {
            required: true,
            message: "请选择行业",
            trigger: "change"
          }
        ],
        totalAssets: [
          { required: true, message: "请选择资产总额", trigger: "change" }
        ],
        practitioner: [
          { required: true, message: "请选择从业人员", trigger: "change" }
        ],
        taking: [
          { required: true, message: "请选择营业收入", trigger: "change" }
        ]
      },
      industryKey: {
        资产总额: { name: "资产总额（万元）", value: "totalAssets" },
        从业人员: { name: "从业人员（人）", value: "practitioner" },
        营业收入: { name: "营业收入（万元）", value: "taking" }
      },
      optionList: {},
      submitKey: {
        0: { ref: "registerForm", name: "基本信息" },
        1: { ref: "YFCXForm", name: "研发创新" },
        2: { ref: "CFCDForm", name: "厂房场地" },
        3: { ref: "RLZYForm", name: "人力资源" },
        4: { ref: "RZSSForm", name: "融资上市" },
        5: { ref: "SCJYForm", name: "生产经营" }
      },
      takingList: []
    };
  },
  components: { Logo },
  mounted() {
    this.getIndustry();
    this.getDropDown("userIndustry", "industryList");
    this.getDropDown("growthStage", "growthStageList");
    this.getDropDown("entType2", "entTypeList");
    this.getDropDown("zczb", "takingList");
    this.getComSearch();
  },
  methods: {
    async getComSearch() {
      let { data } = await getComSearch({ type: 9 });
      this.territoryOption = data;
    },
    /**企业模糊检索 */
    async remoteMethod(query) {
      if (query !== "") {
        this.entNameLoading = true;
        let { data } = await getEntByKeyword({ keyword: query });
        this.entNameLoading = false;
        let listKey = {};
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          listKey[element.SHXYDM] = element.ENTNAME;
        }
        this.entNameListKey = listKey;
        this.entNameList = data;
      } else {
        this.entNameList = [];
      }
    },
    entNameChange(item) {
      this.ruleForm.socialCreditCode = item;
    },
    /**下一步 */
    loginNext() {
      this.$refs[this.submitKey[this.active].ref].validate(async valid => {
        if (valid) {
          this.active++;
        }
      });
    },
    /**上一步 */
    loginPrev() {
      this.$refs[this.submitKey[this.active].ref].validate(async valid => {
        if (valid) {
          this.active--;
        }
      });
    },
    /**提交 */
    handleLogin() {
      this.$refs[this.submitKey[this.active].ref].validate(async valid => {
        if (valid) {
          this.loading = true;
          let params = Object.assign(
            {},
            this.ruleForm,
            this.YFCXForm,
            this.CFCDForm,
            this.RLZYForm,
            this.RZSSForm,
            this.SCJYForm
          );
          params.entName = this.entNameListKey[params.socialCreditCode];
          params.industry = params.industry ? params.industry.join(",") : "";
          params.business = params.business ? params.business.join(",") : "";
          getRegisterUser(params)
            .then(res => {
              if (res.data) {
                this.$message({
                  message: "注册成功，请登录！",
                  type: "success"
                });
                setTimeout(() => {
                  this.$router.push("/login");
                }, 800);
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async mobileClick() {
      let phoneCode = /^1[3456789]\d{9}$/;
      if (!phoneCode.test(this.ruleForm.mobile)) {
        this.$message.error("请输入正确手机号");
      } else {
        let { data } = await getPhoneCode({
          phoneNumber: this.ruleForm.mobile,
          templateId: "SMS_247795134"
        });
        console.log(data);
        this.timeInterval = setInterval(() => {
          this.obtainCode = this.time_s + "S后重试";
          this.time_s--;
          if (this.time_s < 0) {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
            this.time_s = 60;
            this.obtainCode = "获取验证码";
          }
        }, 1000);
      }
    },
    async showIndustry() {
      let { business } = this.ruleForm;
      let { data } = await getList({ hyId: business.at(-1) });
      this.optionList = data;
    },
    async industryChange() {
      let { business } = this.ruleForm;
      console.log(business);
      let { data } = await getList({ hyId: business.at(-1) });
      this.ruleForm.totalAssets = "";
      this.ruleForm.practitioner = "";
      this.ruleForm.taking = "";
      let listData = {};
      for (const key in data) {
        const element = data[key];
        if (key !== "营业收入") {
          listData[key] = element;
        }
      }
      this.optionList = listData;
      // setTimeout(() => {
      //   this.$refs["form"].clearValidate();
      // }, 10);
    },
    async getIndustry() {
      let { data } = await getIndustry();
      this.businessList = data;
    },
    /**下拉条件请求 */
    async getDropDown(type, option) {
      let { data } = await getDropDown({ type: type });

      this[option] = data;
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.content {
  width: 100%;
  background: rgba(246, 246, 246, 1);
  min-height: 100vh;
  header {
    height: 65px;
    margin-bottom: 20px;
    background: #ffffff;
  }
}
.header-view {
  height: 100%;
  width: @contentWidth;
  margin: 0 auto;
  display: flex;
  align-items: center;
  position: relative;
  & .login {
    position: absolute;
    right: 0;
    top: 24px;
    font-size: 16px;
    color: rgba(41, 98, 204, 1);
    &:hover {
      text-decoration: underline;
    }
  }
}
.main {
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto;
  width: @contentWidth;
  margin-top: 20px;
}
.regist-top {
  text-align: center;
  padding-top: 20px;
  & p:nth-of-type(1) {
    color: rgba(49, 47, 47, 1);
    font-size: 20px;
    margin-bottom: 15px;
  }
  & p:nth-of-type(2) {
    color: rgba(213, 213, 213, 1);
    font-size: 16px;
    margin: 0;
  }
}
.register-content {
  padding: 0px 100px 20px 100px;
}
.step-view {
  padding: 50px 100px 20px 100px;
  ::v-deep {
    .el-step__icon {
      width: 48px;
      height: 48px;
      font-size: 22px;
      background: rgba(244, 246, 249, 1);
      border-color: rgba(205, 213, 221, 1);
    }
    .el-step__title {
      font-size: 14px;
    }
    .el-step__title.is-wait {
      color: rgba(166, 166, 166, 1);
    }
    .el-step__title.is-process {
      color: rgba(49, 47, 47, 1);
    }

    .el-step.is-horizontal .el-step__line {
      top: 23px;
    }
    .el-step__head.is-finish {
      .el-step__icon {
        background-color: rgba(20, 96, 212, 1);
        color: #ffffff;
      }
      .el-step__title {
        color: rgba(20, 96, 212, 1);
      }
    }
    .el-step__head.is-process {
      .el-step__icon {
        background-color: rgb(140, 186, 255);
        color: #ffffff;
      }
      .el-step__title {
        color: rgb(140, 186, 255);
      }
    }
  }
}
.step-item {
  & > h3 {
    color: rgba(49, 47, 47, 1);
    font-size: 18px;
  }
}
.custom-code-content {
  ::v-deep {
    .el-form-item__content {
      width: auto;
    }
  }
}
.button-box {
  text-align: center;
  & .el-button {
    background: rgba(41, 99, 204, 1);
    border-color: rgba(41, 99, 204, 1);
  }
}
.register_title {
  padding: 20px 10px;
}
</style>
